/**
=========================================================
* Material Dashboard 2  React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import typography from "assets/theme/base/typography";

function configs2(labels, datasets, xAxisTitle, yAxisTitle, onClickBar, isMobile) {
  return {
    data: {
      labels,
      datasets: [...datasets],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          left: isMobile ? 0 : 10, // 🔥 remove left space on mobile
          right: 10,
          top: 0,
          bottom: 0,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
      },
      scales: {
        y: {
          grid: {
            drawBorder: !isMobile, // ✅ show border
            borderColor: "#344767",
            borderWidth: 1,
            drawOnChartArea: true,
            drawTicks: !isMobile,
          },
          title: {
            display: true, // ✅ always show

            // text: isMobile ? yAxisTitle?.slice(0, 6) + "…" : yAxisTitle, // 👈 shorten on mobile
            text: yAxisTitle,

            color: "#344767",

            font: {
              size: isMobile ? 9 : 12, // 👈 smaller font
              family: typography.fontFamily,
              weight: "bold",
            },

            padding: isMobile
              ? { top: 0, bottom: 0 } // 👈 remove extra spacing
              : { top: 0, bottom: 0 },
          },
          ticks: {
            padding: isMobile ? 2 : 5,
            maxTicksLimit: isMobile ? 4 : 6,
            color: "#9ca2b7",
            font: {
              size: isMobile ? 9 : 11, // 🔥 smaller on mobile
            },
          },
        },
        x: {
          title: {
            display: true,
            text: xAxisTitle,
            align: "center",
            color: "#344767",
            padding: {
              top: 0,
              bottom: 0, // 🔥 removes extra bottom space
            },
            font: {
              size: 12,
              family: typography.fontFamily,
              weight: "bold",
            },
          },

          grid: {
            drawBorder: true, // ✅ show border
            borderColor: "#344767",
            borderWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
          },
          ticks: {
            display: true,
            color: "#9ca2b7",
            padding: isMobile ? 2 : 4,
            font: {
              size: isMobile ? 9 : 11,
            },

            callback: function (value, index) {
              const label = this.getLabelForValue(value);

              if (isMobile) {
                return label.length > 6 ? label.slice(0, 6) + "…" : label;
              }
              return label;
            },
          },
        },
      },
    },
  };
}

export default configs2;
